/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { ReferenceNumberRequest } from '../../models/reference-number-request';
import { Token64LengthType } from '../../models/token-64-length-type';
import { Token64LengthXorEmptyType } from '../../models/token-64-length-xor-empty-type';

export interface PatchExternalReferenceNumberBundle$Params {

/**
 * The delivery note bundle key
 */
  deliveryNoteBundleKey: KeyType;
  accessToken?: Token64LengthXorEmptyType;
  carrierAccessToken?: Token64LengthType;
      body: ReferenceNumberRequest
}

export function patchExternalReferenceNumberBundle(http: HttpClient, rootUrl: string, params: PatchExternalReferenceNumberBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchExternalReferenceNumberBundle.PATH, 'patch');
  if (params) {
    rb.path('deliveryNoteBundleKey', params.deliveryNoteBundleKey, {});
    rb.query('accessToken', params.accessToken, {});
    rb.query('carrierAccessToken', params.carrierAccessToken, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchExternalReferenceNumberBundle.PATH = '/external/delivery-note-bundles/{deliveryNoteBundleKey}/reference-number';
